import { GridCell } from './Cell';
import { GridWrapper } from './Wrapper';

export const Grid = {
  Wrapper: GridWrapper,
  Cell: GridCell,
};
